@if (dialogService.dialog$ | async; as dialog) {
    <app-dialog-general
            (onDialogCancel)="dialogService.respond(false)"
            (onDialogConfirm)="dialogService.respond(true)"
            [bodyText]="dialog.bodyText"
            [cancelButtonText]="dialog.cancelButtonText"
            [confirmButtonText]="dialog.confirmButtonText"
            [danger]="dialog.danger"
            [headerText]="dialog.headerText"
            [showCancelButton]="dialog.showCancelButton">
    </app-dialog-general>
}
